// extracted by mini-css-extract-plugin
module.exports = {"grayscale":"GACoin_grayscale__3s6ST"};